import { z } from 'zod';

import { PaginationSchema } from '../../pagination.js';

import { CustomerRoleStatusSchema } from './customer-role.schemas.js';

export const ListCustomerRoleStatusHistoryQuerySchema = PaginationSchema;

export type ListCustomerRoleStatusHistoryQuery = z.infer<
  typeof ListCustomerRoleStatusHistoryQuerySchema
>;

export const CustomerRoleStatusHistoryEntrySchema = z.object({
  id: z.uuid(),
  customerRoleId: z.uuid(),
  fromStatus: CustomerRoleStatusSchema.nullable(),
  toStatus: CustomerRoleStatusSchema,
  changedByUserId: z.uuid(),
  reason: z.string().nullable(),
  changedAt: z.iso.datetime(),
});

export type CustomerRoleStatusHistoryEntry = z.infer<typeof CustomerRoleStatusHistoryEntrySchema>;

export const ListCustomerRoleStatusHistoryResponseSchema = z.object({
  items: z.array(CustomerRoleStatusHistoryEntrySchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export type ListCustomerRoleStatusHistoryResponse = z.infer<
  typeof ListCustomerRoleStatusHistoryResponseSchema
>;
